import React from 'react';
import TrackedLink from 'components/sanity/TrackedLink';

import { Link } from '../../../../sanity/sanity.types';
import { SanityArrayItem } from '@root/src/types';
import { navItemLink } from '../navEvents';

type Props = {
  links?: SanityArrayItem<Link>[];
  title?: string;
};

const UrlGroup = ({ links, title }: Props) => (
  <div className="space-y-4">
    {title && <h3 className="text-h5">{title}</h3>}

    {links &&
      links.map((link) => (
        <TrackedLink
          key={link._key}
          nav
          navItem={{ ...navItemLink(link, links), footerGroup: title }}
          href={link.href}
          className="text-anchor text-sm block text-gray-darker"
          {...(link.newTab && { target: '_blank', rel: 'noopener noreferrer' })}
        >
          {link.title}
        </TrackedLink>
      ))}
  </div>
);

export default UrlGroup;
